import { useMemo } from 'react';
import { UseLogoMenuProps } from '../../interfaces';
import { HeaderProps } from 'components/Header/interfaces';

export default function useLogoMenu({
	pathname,
	customerId,
	defaultRedirect,
	isGlobalBoundary,
	customerRestriction,
	customerRestrictionRedirect,
	selectedPosId,
	logout,
	refresh,
}: UseLogoMenuProps) {
	const logoButtonProps = useMemo((): HeaderProps['logoButtonProps'] => {
		const logoutBy = {
			'2FAQuit': customerRestriction === '2FA_EXPIRED' && pathname === customerRestrictionRedirect['2FA_EXPIRED'],
			hasNoCustomerId: !customerId,
		};

		if (Object.values(logoutBy).some(Boolean)) {
			return {
				onClick: logout,
				title: 'Ir para página de login',
			};
		}

		if (defaultRedirect === pathname || isGlobalBoundary)
			return {
				onClick: refresh,
				title: 'Recarregar página',
			};

		if (customerRestriction === 'SIMULATED' && selectedPosId) {
			return { href: '/' };
		}

		return { href: defaultRedirect };
	}, [customerId, pathname, customerRestriction, isGlobalBoundary, defaultRedirect, selectedPosId]);

	return { logoButtonProps };
}
